export default "__VITE_ASSET__8734cbfb__"